module.exports = __webpack_public_path__ + "components/MapControl/svg/Budynek zabytkowy.svg?563e2bf6";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Budynek zabytkowy.svg
// module id = 2018
// module chunks = 0